import colors from './colors'

const theme = {
  typography: {
    // fontSize: 13,
    fontFamily: ['Open Sans', 'Archivo', '"sans-serif"'].join(","),
    h1: {
      fontFamily: 'Bitter',
      fontSize: '2.6rem',
      fontWeight: 400,
      lineHeight: 1.25,
      marginBottom: 16,
    },
    h2: {
      fontFamily: 'Bitter',
      fontSize: '2.3rem',
      fontWeight: 400,
      lineHeight: 1.25,
      marginTop: 16,
      marginBottom: 16,
    },
    h3: {
      fontFamily: 'Bitter',
      fontSize: '2rem',
      fontWeight: 400,
      lineHeight: 1.25,
      marginTop: 10,
      marginBottom: 14,
    },
    h4: {
      fontFamily: 'Bitter',
      fontSize: '1.6rem',
      fontWeight: 400,
      lineHeight: 1.25,
      marginTop: 10,
      marginBottom: 12,
    },
    h5: {
      fontFamily: 'Bitter',
      fontSize: '1.4rem',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    subtitle1: {
      fontSize: '1.125rem',
      fontWeight: 400,
      lineHeight: 1.25,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '.875rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    button: {
      fontSize: '1.063rem',
      fontWeight: 500,
    },
    p: {
      fontSize: '1rem',
      marginBottom: 16,
      display: 'block',
    },
  },
  palette: {
    mode: 'light',
    primary: colors.yellow,
    secondary: colors.magenta,
    ...colors,
  },
  shape: {
    // borderRadius: 16,
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        color: 'white',
      },
      styleOverrides: {
        root: {
          boxShadow: 'none',
          paddingTop: 5,
          paddingBottom: 5,
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: ({ theme, ownerState }) => ({
          ...(ownerState.variant === 'padded' && {
            borderRadius: theme.shape.borderRadius * 2,
            marginBottom: theme.spacing(2),
            padding: `${theme.spacing(3)} ${theme.spacing(3)}`,
          }),
        }),
      },
    },
    MuiFormControl: {
      defaultProps: {
        sx: {
          width: '100%',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#b2a017',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        fullWidth: true,
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: '#ff009e',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          textTransform: 'none',
          ...(ownerState.variant === 'text' && {
            color: colors.black.dark,
          }),
          ...(ownerState.variant !== 'text' && {
            ...(ownerState.size === 'large' && {
              padding: `${theme.spacing(2)} ${theme.spacing(6.25)}`,
            }),
            ...(ownerState.color === 'secondary' && {
              backgroundColor: colors.black.dark,
              color: colors.white.main,
              '&:hover': {
                backgroundColor: colors.yellow.main,
                // color: colors.black.dark,
                color: '#000 !important',
              },
            }),
          }),
        }),
      },
    },
    MuiAccordion: {
      defaultProps: {
        elevation: 1,
      },
      styleOverrides: {
        root: {
          borderLeft: '5px solid',
          borderLeftColor: colors.yellow.main,
          '&.MuiPaper-root': {
            margin: 0,
            padding: 0,
          },
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        indicatorColor: 'secondary',
        textColor: 'secondary',
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '0.9rem !important',
          fontWeight: 400,
        },
      },
    },
  },
};

export default theme;
